import type { FaireProductEntity } from "../../entity_types/product";

export const p_a2qhezjz5e: FaireProductEntity = {
  token: "p_a2qhezjz5e",
  type: "product",
  name: "Jesus Listens for Moms, Padded Hardcover, with Full Scriptur",
  brandToken: "b_qy5weejrrs",
  brandName: "HarperCollins Christian Publishing",
  imageUrl:
    "https://cdn.faire.com/fastly/5661267b97fa3e630151f30a24260bcdf4b8f9ecc57c7ca2c076077203f6882a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/656092058452bd23207ea216c3be5377f15633665547f61f692ae584c698aacb.jpeg",
    "https://cdn.faire.com/fastly/b19b55fe226295f378af59ffdf2a56af14af0e83d0648814afd063caae4a431c.jpeg",
    "https://cdn.faire.com/fastly/4956c9625ebb776ff0a7d31c7e32df2ea68db72580d0b3309382e20ecb800cb7.jpeg",
    "https://cdn.faire.com/fastly/67fbf97c2d03f961211761001c30f7a7d1602d6f180e5635c6d2b8ac1b3baf67.jpeg",
    "https://cdn.faire.com/fastly/ca9c3ff0ea4303ab9721c5bda3968ea824f0d4139af5bdbedb8e8bea4b49f68d.jpeg",
    "https://cdn.faire.com/fastly/c4242752748ab6e259f4539274fdc66e9fcebf25d9b8cfd82981d614d7aa48ef.jpeg",
    "https://cdn.faire.com/fastly/b04275cc0f5a0c20f6026111683423accbbeae256895f66358a5c6b31f8df192.jpeg",
    "https://cdn.faire.com/fastly/4ea15aa1159ef51c4af796eed2eb987779f732d870a25dfba011fe1f8894cd87.jpeg",
    "https://cdn.faire.com/fastly/8e6ab639b8f25a7ab5a4daa64872df2eafd48945be1ca0961d71472636b3d715.jpeg",
    "https://cdn.faire.com/fastly/835584973fb7b7ce6383d6541aa44cdd116ca6ffeecf2dd4cae14a4e1c63c6f1.jpeg",
    "https://cdn.faire.com/fastly/564b54524f7f1d9c38d5ae8e0789f73b2913ca83b378e4d8729c54cf4dc2e37d.jpeg",
    "https://cdn.faire.com/fastly/5b57b4329f7b0b939f005d51dc83b596d6c93d74fb63cedabd83e293ff1b2152.jpeg",
    "https://cdn.faire.com/fastly/a6857b798e83801d9ed02ec31e22bc8831e2d7ec5e2201a4968c8c19b68fb00d.jpeg",
  ],
  priceDollars: 13.7,
  description:
    "Jesus Listens for Moms, Padded Hardcover, with Full Scriptures : Prayers for Strength, Comfort, and Encouragement (A 50-Day Devotional)\n\nGive the moms and grandmothers in your life the beautiful gift of prayer and inspiration. Jesus Listens for Moms features 50 prayers from Sarah Young's Jesus Listens along with Scripture and beautiful illustrations to uplift  women of every age and help them talk and walk more closely with Jesus.\n\nWith 50 selections, you'll find prayers that speak to:\n\nThe power of love\nThe gift of strength\nCourage in any season \nTrusting Him during challenging times\nGod's guidance and comfort\n \n\nThis beautiful compilation of prayers also includes:\n\nInspiring illustrations\nComplete Bible verses\nQuotes from Jesus Calling\n \n\nWhether a gift for your own mother, a grandmother, or another special mom in your life, this is ideal for Mother's Day, birthdays, and more. Jesus Listens for Moms will be a cherished favorite for years to come.\n\nLook for additional life-changing, life-giving books from Sarah Young including:\n\nJesus Listens\nJesus Always\nJesus Today\nJesus Calling",
  tags: [],
  msrpDollars: 27.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:40.110Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
